module.exports = __webpack_public_path__ + "img/artboard2.fa5ca1d9.jpg";